import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';
import { RightCol } from '@components/HealthQuoteBuyRoute/right-col';
import HealthQuoteBuyForm, { FormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyForm';

import { cancerQuoteUpdate, CancerQuoteUpdatePayload } from '../action';
import { useCancerQuoteFetch } from '../hook';
import { useInitialValues } from './hook';

const CancerQuoteBuyEditPage = () => {
  const dispatch = useDispatch();
  const cancerQuote = useCancerQuoteFetch();
  const initialValues = useInitialValues();

  if (isUndefined(cancerQuote)) return <Loading />;
  if (isNull(cancerQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const {
    orderNumber,
    cancerPlanName,
    cancerPlanQuestions,
    occupationDeclarationDescription } = cancerQuote;

  const handleSubmit = (values: FormValues) => {
    const payload: CancerQuoteUpdatePayload = { orderNumber, ...values };
    dispatch(cancerQuoteUpdate(payload));
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <HealthQuoteBuyForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            questions={cancerPlanQuestions}
            description={occupationDeclarationDescription} />
        </Col>
        <RightCol {...cancerQuote} planName={cancerPlanName} />
      </Row>
    </Container>
  );
};

export { CancerQuoteBuyEditPage };
